import { render, staticRenderFns } from "./BannerModal.vue?vue&type=template&id=724aab2b&scoped=true"
import script from "./BannerModal.vue?vue&type=script&lang=js"
export * from "./BannerModal.vue?vue&type=script&lang=js"
import style0 from "./BannerModal.vue?vue&type=style&index=0&id=724aab2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724aab2b",
  null
  
)

export default component.exports